import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import PaginationComponent from "./paginationComponent";
import { Badge, Button, Icon, Layout, List, Stack, Tabs, ThemeProvider, Tooltip } from "@shopify/polaris";
import _ from 'lodash';
import { showingGridRange } from "./showgridrange";
import Actionbar from "./actionbar";
import FilterComponent from "./filterComponent";
import { FilterMajorMonotone } from "@shopify/polaris-icons";
import Toolbar from '../../shared/react-data-grid/Toolbar';
import { getFilterSentence, prepareChoiceoption } from "./gridHelper";
import NewToolbar from './NewToolbar';
import { isUndefined } from 'util';
// import CustomNoRowsOverlay from '../../Components/Products/CustomNoRowsOverlay';

class Grid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // frameworkComponents: {
            //     customNoRowsOverlay: CustomNoRowsOverlay,
            // },
            // noRowsOverlayComponent: 'customNoRowsOverlay',
            // noRowsOverlayComponentParams: {
            //     noRowsMessageFunc: () => 'Sorry - no rows! at: ',
            // },
            filterCollapsible: false,
            suffix: this.props.suffix,
        }
    }

    markNodeSelected(event, selectedRows) {
        //console.log(event.api)
        if (event) {
            event.api.forEachNode((node) => {
                selectedRows.forEach(data => {
                    if (_.isEqual(data, node.data)) {
                        node.setSelected(_.isEqual(data, node.data));
                    }
                })
            });
        }
    }

    sendSelectedRows(isSelected, data) {
        let { rowSelected, selectedRows } = this.props;
        if (selectedRows) {
            selectedRows.slice(0);
            if (isSelected) {
                if ((selectedRows.filter(row => _.isEqual(row, data))).length === 0) selectedRows.push(data);
            } else selectedRows = (selectedRows.filter(row => !_.isEqual(row, data))).slice(0);
            if (rowSelected) rowSelected(selectedRows);
        }
    }

    getRowHeights(rowHeight = 100) {
        return rowHeight;
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            // updatedSize:nextProps.columns ,
            massAction: nextProps.massAction
        }, () => {
            // console.log(this.state.massAction);
            // this.handleResize()
        });
        // this.handleResize(true);
    }

    filterCollapsibleFunc = () => {
        this.setState({
            filterCollapsible: !this.state.filterCollapsible
        })
    }

    getTooltipList(arr){
        return (
            <List type='bullet'>
                {arr.map(val=>{
                    return <List.Item>{val}</List.Item>
                })}
            </List>
        )
    }

    render() {
        let { filterCollapsible } = this.state;
        let { columns, rows, tag, suppressRowClickSelection, selectedRows, selectedTab, suppressSizeToFit, suppressMovableColumns, enableCellTextSelection, rowSelection, paginationProps, getGridApi, onpaginationChange, cellClickedEvent, rowClickedEvent, onSelectAction, selectedActions, showFilters, filterData, filtersProps, tabs, tabSelected, showTabs, customRowHeight } = this.props;
        if (!selectedRows) selectedRows = [];
        let arr=[];
        showFilters && filtersProps.filters.length>0 && 
            filtersProps.filters.map(val=>{
                var obj = getFilterSentence(val, filtersProps.attributeoptions, filtersProps.filterCondition)
                arr.push(obj)
            })
            // console.log(selectedTab,"CALL")
        return (
            <div>  
                {showTabs &&
                    <React.Fragment>
                        <Tabs tabs={tabs} fitted={true} selected={selectedTab} onSelect={tabSelected.bind(this)} />
                        <br />
                    </React.Fragment>
                }
                <Stack vertical={false} distribution={"equalSpacing"}>
                    {
                        // selectedActions && selectedActions.length>0 && selectedRows.length>0 &&
                        // <Actionbar label={`Selected ${selectedRows.length} ${tag}`} onSelectAction={onSelectAction} selectedActions={selectedActions}/>
                        <NewToolbar {...this.props} selected_count={selectedRows.length} toolbar_suffix={this.state.suffix} massAction={this.state.massAction} />
                        // <h1>ngh</h1>

                    }
                    {paginationProps &&
                        <p style={{ paddingTop: 5, fontWeight: 'bold' }}>{showingGridRange(paginationProps, tag)}</p>
                    }
                    <Stack.Item>
                        <Stack vertical={false}>
                            {paginationProps &&
                                <Stack vertical={false}>
                                    <PaginationComponent paginationProps={paginationProps} paginationChanged={onpaginationChange} />
                                </Stack>
                            }
                            {showFilters &&
                                // <Tooltip content="Filters">
                                filtersProps.filters.length > 0 ?
                                <Tooltip active={false} content={this.getTooltipList(arr)}>
                                <Button
                                    // plain={true}
                                    icon={FilterMajorMonotone}
                                    disclosure={!filterCollapsible ? "down" : "up"}
                                    onClick={() => {
                                        
                                        this.setState({ filterCollapsible: !filterCollapsible });
                                    }}
                                    ariaExpanded={filterCollapsible}
                                    ariaControls="filter-collapsible"
                                    primary={true}
                                >
                                    <Layout><div style={{marginLeft:"-8rem"}}><Badge>{filtersProps.filters.length}</Badge></div></Layout>
                                    Filters Applied
                                </Button>
                                </Tooltip> : showFilters &&
                                <Button
                                    // plain={true}
                                    icon={FilterMajorMonotone}
                                    disclosure={!filterCollapsible ? "down" : "up"}
                                    onClick={() => {
                                        this.setState({ filterCollapsible: !filterCollapsible });
                                    }}
                                    ariaExpanded={filterCollapsible}
                                    ariaControls="filter-collapsible"
                                    primary={false}
                                >
                                    Filters
                                </Button>
                            }
                        </Stack>
                    </Stack.Item>
                </Stack>

                {showFilters &&
                    <React.Fragment>
                        <FilterComponent filtersProps={filtersProps} filterData={filterData}
                            filterCollapsible={filterCollapsible}
                            filterCollapsibleFunc={this.filterCollapsibleFunc}
                             />
                    </React.Fragment>
                }
                <ThemeProvider theme={{ colorScheme: "light" }}>
                    <div
                        className="ag-theme-alpine"
                        style={{ height: window.innerHeight, overflowX: 'scroll' }}
                    >
                        <AgGridReact
                            columnDefs={columns}
                            rowData={rows}
                            getRowHeight={customRowHeight ? this.getRowHeights.bind(this, customRowHeight) : false}
                            suppressRowClickSelection={suppressRowClickSelection}
                            suppressMovableColumns={suppressMovableColumns}
                            enableCellTextSelection={enableCellTextSelection}
                            rowSelection={rowSelection}
                            onGridReady={params => {
                                this.gridApi = params.api;
                                this.gridColumnApi = params.columnApi;
                                getGridApi(params.api);
                                if (suppressSizeToFit) {
                                    this.gridApi.sizeColumnsToFit();
                                }
                            }}
                            onRowSelected={(event) => {
                                this.sendSelectedRows(event.node.isSelected(), event.data);
                            }}
                            onRowClicked={(event) => {
                                if (rowClickedEvent) rowClickedEvent(event.data);
                            }}
                            onCellClicked={(event => {
                                // console.log(event);
                                if (cellClickedEvent) cellClickedEvent(event.colDef, event.data, event.rowIndex)
                            })}
                            onRowDataChanged={(event) => {
                                this.gridApi=event.api;
                                this.gridApi.deselectAllFiltered()
                                this.markNodeSelected(event, selectedRows);
                            }}
                            frameworkComponents={this.props.frameworkComponents}
                            noRowsOverlayComponent={this.props.noRowsOverlayComponent}
                            noRowsOverlayComponentParams={
                                this.props.noRowsOverlayComponentParams
                            }
                        >

                        </AgGridReact>
                    </div>
                </ThemeProvider>


            </div>

        );
    }
}

export default Grid;